import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large reset-password-container"
  }, [_c("BackgroundVideo"), _c("div", {
    staticClass: "container-centered small-2"
  }, [!_vm.resetDone && !_vm.serverError ? _c("div", [_c("h2", {
    staticClass: "title-margin-b"
  }, [_vm._v("Please type your e-mail address.")]), _c("div", [_c(VTextField, {
    attrs: {
      label: "E-mail address",
      placeholder: "john.doe@domain.com",
      autofocus: ""
    },
    model: {
      value: _vm.input.mail,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "mail", $$v);
      },
      expression: "input.mail"
    }
  }), _vm.mailError.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(_vm._s(_vm.mailError))]) : _vm._e()], 1), _c("div", [_c(VBtn, {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ["enter"],
      expression: "['enter']"
    }],
    staticClass: "reset-button",
    attrs: {
      rounded: true,
      loading: _vm.isReseting
    },
    on: {
      click: function click($event) {
        return _vm.reset();
      }
    },
    nativeOn: {
      shortkey: function shortkey($event) {
        return _vm.reset();
      }
    }
  }, [_vm._v(" RESET PASSWORD ")])], 1)]) : _vm._e(), _vm.resetDone && !_vm.serverError ? _c("div", [_c("h2", {
    staticClass: "title-margin-b"
  }, [_vm._v("Request of password reset")]), _c("div", [_vm._v("You'll soon receive an e-mail to choose a new password.")]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --with-dark-bg",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.home();
      }
    }
  }, [_vm._v("HOME")])], 1)]) : _vm._e()]), _vm.serverError ? _c("Error", {
    attrs: {
      error: _vm.errorMessages.error,
      darkBg: true
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };